import React from 'react'
import dayjs from 'dayjs'
import { Value } from '../../elements'

export interface MobileField {
  key: string
  label: string
  render?: (value: any, record: any) => React.ReactNode
}

export const getMobileFields = (): MobileField[] => [
  {
    key: 'created_at',
    label: 'Дата рекламации',
    render: (val) => (val ? dayjs(val).format('DD.MM.YYYY') : <Value data={val} />),
  },
  {
    key: 'address',
    label: 'Адрес',
    render: (val) => <Value data={val} />,
  },
  {
    key: 'name',
    label: 'ФИО',
    render: (val) => <Value data={val} />,
  },
  {
    key: 'phone',
    label: 'Телефон',
  },
]


